import { createFileRoute, Link } from '@tanstack/react-router'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { monolingualPageHead } from '~/lib/site-meta'
import { HELP_ARTICLES, HELP_CATEGORIES } from '~convex/lib/help'

const PAGE_TITLE = 'Central de ajuda | Planno'
const PAGE_DESCRIPTION =
  'Como usar o Planno: funil e projetos, tarefas, visitas de obra, propostas e o Assistente no WhatsApp.'

export const Route = createFileRoute('/ajuda/')({
  component: HelpIndex,
  head: () =>
    monolingualPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/ajuda',
      title: PAGE_TITLE,
    }),
})

/**
 * The help hub — every article, grouped the way the app's own sidebar groups
 * things, so someone arriving with the product in front of them recognises the
 * shape.
 *
 * It is also the crawl surface: the build prerenders by following links, so an
 * article that is not linked from here does not get prerendered. Listing every
 * article rather than a curated selection is load-bearing, not a design choice.
 */
function HelpIndex() {
  return (
    <MarketingShell>
      <div className="mx-auto w-full max-w-[52rem] px-5 pt-16 pb-24 sm:px-8">
        <header className="pb-12">
          <h1 className="font-semibold text-[#0b0b0d] text-[2.25rem] leading-[1.1] tracking-[-0.02em] sm:text-[2.75rem]">
            Central de ajuda
          </h1>
          <p className="max-w-[38rem] pt-4 text-[#57575f] text-[1.0625rem] leading-relaxed">
            {PAGE_DESCRIPTION}
          </p>
        </header>

        <div className="space-y-12">
          {HELP_CATEGORIES.map((category) => {
            const articles = HELP_ARTICLES.filter((article) => article.category === category.key)
            if (articles.length === 0) {
              return null
            }
            return (
              <section key={category.key}>
                <h2 className="font-semibold text-[#0b0b0d] text-[1.25rem] tracking-[-0.01em]">
                  {category.label}
                </h2>
                <p className="pt-1 pb-5 text-[#77777f] text-sm">{category.blurb}</p>
                <ul className="grid gap-3 sm:grid-cols-2">
                  {articles.map((article) => (
                    <li key={article.slug}>
                      <Link
                        className="block h-full rounded-xl border border-black/10 bg-white p-5 transition-colors hover:border-black/25"
                        params={{ slug: article.slug }}
                        to="/ajuda/$slug"
                      >
                        <span className="block font-medium text-[#0b0b0d]">{article.title}</span>
                        <span className="block pt-1.5 text-[#57575f] text-sm leading-relaxed">
                          {article.summary}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>
            )
          })}
        </div>
      </div>
    </MarketingShell>
  )
}
